export type LanguageCode = 'en' | 'de' | 'vi' | 'fr';

export const LANGUAGE_OPTIONS: Record<
  LanguageCode,
  { label: string; countryCode: string; countryLabel: string }
> = {
  en: { label: 'English (EN)', countryCode: 'gb', countryLabel: 'GB English' },
  de: { label: 'German (DE)', countryCode: 'de', countryLabel: 'DE German' },
  vi: { label: 'Vietnamese (VI)', countryCode: 'vn', countryLabel: 'VN Vietnamese' },
  fr: { label: 'French (FR)', countryCode: 'fr', countryLabel: 'FR French' },
};

const LANGUAGE_CODES = Object.keys(LANGUAGE_OPTIONS) as LanguageCode[];

type LanguageFlagProps = {
  countryCode: string;
  className?: string;
  title?: string;
};

export function LanguageFlag({ countryCode, className = 'h-3.5 w-3.5', title }: LanguageFlagProps) {
  return (
    <span
      className={`fi fis fi-${countryCode.toLowerCase()} inline-block shrink-0 rounded-sm ${className}`}
      title={title}
      aria-hidden={title ? undefined : true}
    />
  );
}

export function LanguageFlagByCode({ code, className }: { code: LanguageCode; className?: string }) {
  const option = LANGUAGE_OPTIONS[code];
  return (
    <LanguageFlag
      countryCode={option.countryCode}
      className={className}
      title={option.label}
    />
  );
}

export function resolveLanguageCountryCode(value: string): string | null {
  if (LANGUAGE_CODES.includes(value as LanguageCode)) {
    return LANGUAGE_OPTIONS[value as LanguageCode].countryCode;
  }

  const matched = Object.values(LANGUAGE_OPTIONS).find((option) => option.label === value);
  return matched?.countryCode ?? null;
}
